<vdw-crud-grid-with-actions
  [withNewClicked]="config.withNewClicked"
  [rowData]="config.rowData"
  [gridOptions]="config.gridOptions"
  [entityName]="config.entityName"
  [canShowActions]="canShowActions"
  [showCustomSettingsButton]="showCustomSettingsButton"
  [loadingForTheFirstTime]="loadingForTheFirstTime"
  (showCustomSettings)="config.withCustomSettingsClicked()"
/>
